import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import ContractVersionUpdate from 'modules/contracts/components/ContractHistory/ContractVersionUpdate'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

import { useInitialConditions } from './useInitialConditions'

interface Props {
  contractVersion: ContractVersion
}

const InitialConditions = ({ contractVersion }: Props) => {
  const initialConditions = useInitialConditions(contractVersion)

  return (
    <Box paddingTop="s8">
      <Box
        component="ul"
        gap="s4"
        paddingX="s24"
        paddingTop="s16"
        border={{
          top: {
            width: 's2',
            style: 'solid',

            color: 'grey400',
          },
        }}
      >
        {initialConditions.map((update, index) => {
          return <ContractVersionUpdate update={update} key={index} />
        })}
      </Box>
    </Box>
  )
}

export default observer(InitialConditions)
